import * as React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex } from 'roo-ui/components';

const Styled = styled(Flex)`
  animation: ${themeGet('keyframes.fadeIn')} ${themeGet('transitions.quickFadeIn')};
  transition: box-shadow 0.2s ease-in-out;
  margin-bottom: 20px;

  &:hover {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  }

  ${themeGet('mediaQueries.0')} {
    min-height: 180px;
  }
`;

export const CardWrapper = ({ children, ...rest }: React.PropsWithChildren<any>) => (
  <Styled
    flexDirection={['column', 'row']}
    bg="white"
    borderRadius="default"
    boxShadow="default"
    height="auto"
    {...rest}
    data-testid="booking-list-card"
  >
    {children}
  </Styled>
);
